var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpSocDisIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.897461,
    y: 1.18604,
    width: 47,
    height: 47,
    rx: 11.5,
    fill: "#FFE500",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.897461,
    y: 1.18604,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#FFE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3975 15.686H20.3975C17.636 15.686 15.3975 17.9246 15.3975 20.686V28.686C15.3975 31.4475 17.636 33.686 20.3975 33.686H28.3975C31.1589 33.686 33.3975 31.4475 33.3975 28.686V20.686C33.3975 17.9246 31.1589 15.686 28.3975 15.686Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2553 21.3229C20.3701 21.1297 20.545 20.9792 20.7531 20.8944C23.0915 19.9496 25.7054 19.9496 28.0437 20.8944C28.2519 20.9792 28.4267 21.1297 28.5416 21.3229C29.597 23.1113 30.056 25.1893 29.8521 27.2559C29.8209 27.5663 29.6448 27.8437 29.3772 28.004C28.9932 28.2317 28.5941 28.4326 28.1825 28.6054C27.7054 28.8083 27.1521 28.6194 26.8987 28.1671C26.7446 27.8881 26.6031 27.6015 26.4743 27.3071C25.1068 27.6087 23.6901 27.6087 22.3225 27.3071C22.1936 27.601 22.0521 27.8876 21.8982 28.1671C21.6447 28.6194 21.0914 28.8082 20.6144 28.6054C20.2028 28.4326 19.8036 28.2317 19.4197 28.004C19.1521 27.8437 18.976 27.5663 18.9447 27.2559C18.7409 25.1893 19.1998 23.1113 20.2553 21.3229Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0225 24.586C26.0222 24.655 25.9662 24.7107 25.8972 24.7105C25.8282 24.7103 25.7724 24.6543 25.7725 24.5853C25.7726 24.5164 25.8285 24.4605 25.8975 24.4605C25.9308 24.4603 25.9628 24.4735 25.9863 24.4971C26.0097 24.5207 26.0228 24.5527 26.0225 24.586Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0225 24.586C23.0222 24.655 22.9662 24.7107 22.8972 24.7105C22.8282 24.7103 22.7724 24.6543 22.7725 24.5853C22.7726 24.5164 22.8285 24.4605 22.8975 24.4605C22.9308 24.4603 22.9628 24.4735 22.9863 24.4971C23.0097 24.5207 23.0228 24.5527 23.0225 24.586Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpSocDisIcon);
export default __webpack_public_path__ + "static/media/lp_soc_dis_icon.bdc193967c837942aea2dc0bd19e9f22.svg";
export { ForwardRef as ReactComponent };